import { useEffect } from 'react';
import {
  useCreateDoaLinkMutation,
  useDeleteDoaLinkMutation,
  useLazyGetDOALinkDataQuery,
  useLazyGetPageLevelSignDataQuery,
  useLazyUpdatePageLevelSignatureQuery,
  usePublishDOAtoISFMutation,
  useUpdateDoaLinkMutation,
  useUpdateLinkSignatureMutation
} from 'src/services/DOA';
import { useAppDispatch } from 'src/store/hooks';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { checkGetProperty } from 'src/util/STR';
import { updateUserAccess } from 'src/util/util';

export const useDOA = () => {
  const dispatch = useAppDispatch();
  const [
    getDOALinkQueryData,
    {
      isLoading: getDOALinkLoading,
      isError: getDOALinkIsError,
      data: doaLinkQueryData,
      error: getDOALinkError,
      isSuccess: getDOALinkIsSuccess
    }
  ] = useLazyGetDOALinkDataQuery();

  const [
    updateDOALinkSign,
    { isLoading: updateDOALinkSignLoading, data: updateDOALinkSignData, error: updateDOALinkSignError }
  ] = useUpdateLinkSignatureMutation();
  const [
    getPageLevelSignData,
    {
      isLoading: pageLevelSignDataLoading,
      isError: pageLevelSignDataIsError,
      data: pageLevelSignData,
      error: pageLevelSignDataError,
      isSuccess: pageLevelSignDataIsSuccess
    }
  ] = useLazyGetPageLevelSignDataQuery();
  const [
    updatePageLevelSignature,
    {
      isLoading: updatePageLevelSignLoading,
      isError: updatePageLevelSignIsError,
      data: updatePageLevelSignData,
      error: updatePageLevelSignError,
      isSuccess: updatePageLevelSignIsSuccess
    }
  ] = useLazyUpdatePageLevelSignatureQuery();
  const [
    updateDOALink,
    { isLoading: updateDOALinkLoading, error: updateDOALinkError, isSuccess: updateDOALinkIsSuccess }
  ] = useUpdateDoaLinkMutation();

  const [
    createDOALink,
    { isLoading: createDOALinkLoading, error: createDOALinkError, isSuccess: createDOALinkIsSuccess }
  ] = useCreateDoaLinkMutation();

  const [
    deleteDOALink,
    { isLoading: deleteDOALinkLoading, error: deleteDOALinkError, isSuccess: deleteDOALinkIsSuccess }
  ] = useDeleteDoaLinkMutation();

  const [publishDOAtoISF, { isLoading: updatePublishDOAtoISFLoading }] = usePublishDOAtoISFMutation();

  useEffect(() => {
    if (deleteDOALinkIsSuccess) {
      dispatch(setMessage({ msgDetails: 'Log Deleted successfully', severity: 'success' }));
    }
  }, [deleteDOALinkIsSuccess]);

  useEffect(() => {
    if (createDOALinkIsSuccess || updateDOALinkIsSuccess) {
      dispatch(setMessage({ msgDetails: 'Record saved successfully.', severity: 'success' }));
    }
  }, [createDOALinkIsSuccess, updateDOALinkIsSuccess]);
  useEffect(() => {
    if (updateDOALinkSignError || getDOALinkError || updateDOALinkError || deleteDOALinkError) {
      updateUserAccess(updateDOALinkSignError || getDOALinkError || updateDOALinkError || deleteDOALinkError, dispatch);
    }
    if (createDOALinkError) {
      const status = checkGetProperty(createDOALinkError, 'status');
      const data = checkGetProperty(createDOALinkError, 'data');
      if (status === 500 && data?.context?.message === 'duplicate entry') {
        dispatch(setMessage({ msgDetails: 'Duplicate entry', severity: 'info' }));
      } else {
        updateUserAccess(createDOALinkError, dispatch);
      }
      if (status !== 500 && status !== 401 && status !== 403) {
        dispatch(setMessage({ msgDetails: 'Error in saving record', severity: 'error' }));
      }
    }
  }, [updateDOALinkSignError, getDOALinkError, updateDOALinkError, createDOALinkError, deleteDOALinkError]);

  useEffect(() => {
    if (
      updateDOALinkSignLoading ||
      pageLevelSignDataLoading ||
      updatePageLevelSignLoading ||
      updateDOALinkLoading ||
      createDOALinkLoading ||
      deleteDOALinkLoading ||
      updatePublishDOAtoISFLoading ||
      getDOALinkLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    updateDOALinkSignLoading,
    pageLevelSignDataLoading,
    updatePageLevelSignLoading,
    updateDOALinkLoading,
    createDOALinkLoading,
    deleteDOALinkLoading,
    updatePublishDOAtoISFLoading,
    getDOALinkLoading
  ]);

  return {
    doaLinkQueryData,
    getDOALinkError,
    getDOALinkIsError,
    getDOALinkIsSuccess,
    getDOALinkQueryData,
    updateDOALinkSign,
    pageLevelSignDataLoading,
    pageLevelSignDataIsError,
    pageLevelSignDataError,
    pageLevelSignDataIsSuccess,
    pageLevelSignData,
    getPageLevelSignData,
    updatePageLevelSignLoading,
    updatePageLevelSignIsError,
    updatePageLevelSignData,
    updatePageLevelSignError,
    updatePageLevelSignIsSuccess,
    updatePageLevelSignature,
    updateDOALinkSignData,
    updateDOALink,
    createDOALinkIsSuccess,
    createDOALink,
    deleteDOALink,
    publishDOAtoISF
  };
};
